import { useEffect, useState } from "react";
import { _DocumentFactory, _EmployeeContract, _EmployeeContractHistory, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { SelectMonths } from "../../../contract/select/SelectMonths";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { EntailmentEditor } from "../../ParametrosTalentoHumano/Entailment/Entailment.editor";
import { AppointmentEditor } from "../../ParametrosTalentoHumano/Appointment/Appointment.editor";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../theme/Component/BasicTable";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { MultiAccountanEditor } from "../../../editor/MultiAccountanEditor";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { ContractHistory } from "./ComponentsContract/ContracHistory/ContractHistory";
import { CDPLink } from "./ComponentsContract/CdpLink/CDPLink";
import { ConstractStateEditor } from "./ComponentsContract/EditorsEmployeContrac/ConstractState.editor";
import { InputDate } from "../../../theme/Input/InputDate";
import { EmploymentTypeEditor } from "./ComponentsContract/EditorsEmployeContrac/EmploymentType.editor";
import { ExportEmployeeContract } from "./ComponentsContract/ExportEmployeeContract/ExportEmployeeContract";
import { ImportEmployeeContract } from "./ComponentsContract/ImportEmployeeContract/ImportEmployeeContract";
import { SelectFunctionalArea } from "../../../admin/configuracion/FunctionalArea/SelectFunctionalArea";
import usePaginator from "../../../theme/Component/usePaginator";
import { DropDown } from "../../../theme/Component/DropDown";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";
import { CostingCenterSelect } from "../../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { toast } from "react-toastify";
import { ImportXLSX } from "../../../theme/Component/ImportXLSX";
import { _CostingCenterHistory, _DataForEndup, _Reprovision, _UptoDateEmployee } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { CostingCenterHistoryCatalog } from "./CostingCenterHistoryCatalog/CostingCenterHistoryCatalog";
import { PayrollDocumentCatalog } from "./PayrollDocumentCatalog/PayrollDocumentCatalog";
import { EmployeeID } from "../../DigitalID/EmployeeID";
import { AppointmentCatalog } from "../../ParametrosTalentoHumano/Appointment/AppointmentCatalog/AppointmentCatalog";
import { FileInput } from "../../../theme/Component/FileInput";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { ProvisionCatalog } from "./ProvisionCatalog/ProvisionCatalog";
import { AccountantYear } from "./ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { IBCCatalog } from "./IBCCatalog/IBCCatalog";
import { EditEmployeeContract } from "./EditEmployeeContract";
import { EmployeeDossier } from "./EmployeeDossier/EmployeeDossier";

export const EmployeeContract = () => {

    const employeeContract = useDataBean(_EmployeeContract);
    const hisotryContract = useDataBean(_EmployeeContractHistory);
    const CostingCenterHistory = useDataBean(_CostingCenterHistory);
    const _documentos = useDataBean(_DocumentFactory);
    const reprovision = useDataBean(_Reprovision);
    const impvalue = useDataBean(_DataForEndup);
    const upto = useDataBean(_UptoDateEmployee);
    const single = Singleton.getInstance();
    const [bean, setBean] = useState<any>({});
    const [form, setForm] = useState<any>({
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth()
    });
    const [vigencia, setVigenia] = useState<number>(single.getCurrenYear());
    const [registers, setRegisters] = useState<number>(15);
    const [month, setMonth] = useState<number>(single.getCurrentMonth());
    // const [planta, setPlanta] = useState<string>(null);
    const [employmentType, setEmploymentType] = useState<number>(null);
    const [regexStx, setRegexStx] = useState<string>(null);
    const [funtional, setFuntional] = useState<number>(null);
    const [entailment, setEntailment] = useState<number>(null);
    const [appointment, setAppointment] = useState<number>(null);
    const [idSite, setIdSite] = useState<number>(null);
    const [contractState, setContractState] = useState<number>(null);
    const [lista, setLista] = useState<any>([]);
    const [listaAccs, setListaAccs] = useState<any>([]);
    const [listE, setListE] = useState<any>([]);
    const [docs, setDocs] = useState<any>([]);
    const [modalPROV, setModalPROV] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcalculate, setModalcalculate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalDocLiq, setModalDocLiq] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalimpvalue, setModalimpvalue] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcosto, setModalcosto] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalacciones, setModalacciones] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalhistorico, setModalhistorico] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalExport, setModalExport] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalImport, setModalImport] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalAddHistory, setModalAddHistory] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalIBC, setModalIBC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalHistory, setModalHistory] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalLinkCDP, setModalLinkCDP] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalUpdateParameters, setModalUpdateParameters] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const modalExportList = useModal("Exportar Historial", MODAL_SM);
    const modaldate = useModal("Actualizar Fecha", MODAL_LG);
    const modifySalary = useModal("Modificar Nivel Salarial de Contrato", MODAL_md);
    const modifyArea = useModal("Modificar Plaza Laboral de Contrato", MODAL_md);
    const modalCarnet = useModal("Identificación", MODAL_md);
    const modalDossier = useModal("Hoja de Vida", MODAL_md);

    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])
    useEffect(() => {
        if (modalDocLiq.view) {
            verDocumentos();
        }
    }, [modalDocLiq.view]);
    const getLista = () => {
        setBean({});
        paginador.setRegiPerPage(registers)

        employeeContract.instance.getEmployeeContracts(vigencia, month, listaAccs.length ? listaAccs : null, employmentType ? [employmentType] : null, funtional, entailment, appointment, contractState, idSite, regexStx, paginador.page, registers).then(
            (resp) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (registers ?? 15));
                    paginador.setRegiPerPage(registers)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.DocLiq = (user.DataBeanProperties.CNFMnemonic ?? "") + "-" + (user.DataBeanProperties.CNFConsecutive ?? "") + "-" + (user.DataBeanProperties.CNFDate ?? "");

                    });
                    setLista(x)
                }
            }
        ).catch(
            err => { toast.error(err) }
        )
    }
    const verDocumentos = () => {

        if (bean.CNFDocumentLocation) {
            _documentos.instance.getPdfAccountantDocument(bean.CNFDocumentLocation, null, bean.CNFDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    // setregistro({ ...registro, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const getListaReport = () => {
        paginador.setRegiPerPage(registers)
        ////console.log(vigencia, month, listaAccs.length > 0 ? listaAccs : null, employmentType, funtional, entailment, appointment, contractState, idSite, registers, paginador.page, regexStx)

        employeeContract.instance.getEmployeeContracts(vigencia, month, listaAccs.length ? listaAccs : null, employmentType ? [employmentType] : null, funtional, entailment, appointment, contractState, idSite, regexStx, null, null).then(
            (resp) => {
                if (resp) {
                    setListE(resp.List)
                }
            }
        )
    }

    const update = () => {

        const copy = { ...bean }
        copy.IDEmployeeLastUpdate = single.getAccountID();

        if (!bean.modifyDate) {
            delete copy.EndingDate;
            delete copy.UptoContract;

            setBean(copy);
            setTimeout(() => {
                console.log("despues de borrar", copy);
            }, 500);
        }

        if (!bean.IDPayrollType) {
            toast.error("Debe seleccionar el Tipo de Nómina antes de continuar.");
            return;
        }


        employeeContract.updateCustonBean(copy).then((resp) => {
            single.update(bean);
            getLista();
            setBean({});
            setModal({ ...modal, view: false });
        });
    };

    const updateFunctionalArea = () => {
        employeeContract.instance.updateFunctionalAreaAndAppointmentForEmployeeContract(bean.IDContract, bean.fromDate, bean.IDAppointment, bean.IDLnFunctionalArea, single.getAccountID()).then(
            (resp) => {
                //console.log(resp)
                getLista();
                setModalUpdateParameters({ ...modalUpdateParameters, "view": false })
                single.update(bean)
                setBean({})
            }
        )
    }

    const importEmployeeContractDataForEndup = () => {
        impvalue.instance.importEmployeeContractDataForEndup(impvalue.bean.Media, impvalue.bean.MediaContext, null).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Importado')
                setModalimpvalue({ ...modalimpvalue, "view": false })
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const create = () => {
        hisotryContract.instance.createEmployeeContractHistory(bean.IDContract, bean.IDAppointment ?? null, bean.InitDate, bean.UptoDate, bean.LastSalary ?? null, single.getAccountID()).then(
            (resp) => {
                //console.log(resp)
                single.create({ IDContract: bean.IDContract, IDAppointment: bean.IDAppointment, from: bean.InitDate, upto: bean.UptoDate, LastSalary: bean.LastSalary, IDEmployee: single.getAccountID() })
                setModalAddHistory({ ...modalAddHistory, "view": false })
                setBean({})
                getLista();
            }
        )
    }

    const addCostingCenterHistory = () => {
        CostingCenterHistory.instance.addCostingCenterHistory(bean.IDContract, CostingCenterHistory.bean.FromDate, CostingCenterHistory.bean.CostingCenterCode).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Agregado')
                setModalcosto({ ...modalcosto, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const updateUptoDateEmployeeContracts = () => {
        upto.instance.updateUptoDateEmployeeContracts(_single.getAccountID(), upto.bean.Media, upto.bean.MediaContext).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Actualizado')
                modaldate.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const recalculateEmployeeProvisions = () => {

        reprovision.instance.recalculateEmployeeProvisions(bean.IDContract, form.Year, form.Month).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Recalculado')
                setModalcalculate({ ...modalcalculate, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const verimp = () => {
        setModalimpvalue({ ...modalimpvalue, "view": true })
    }
    const head = [
        { title: 'IDContrato', property: 'IDContract', visible: true, mask: MASK_NUMBER },
        { title: 'Codigo', property: 'Code', visible: true },
        { title: 'Estado', property: 'ContractStateName', visible: true },
        { title: 'Usuario', property: 'AccountName', visible: true, mask: MASK_TEXT_NOWRAP },
        // { title: 'Perfil de Liquidación', property: 'IDEmployeeLiquidate', visible: true },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: true },

        { title: 'Nivel Salarial/Grado', property: 'AppointmentName', visible: true },
        { title: 'Tipo Vinculación', property: 'ContractTypeName', visible: true },
        { title: 'ID Plaza Laboral', property: 'IDLnFunctionalArea', mask: MASK_NUMBER, visible: true },
        { title: 'Plaza Laboral', property: 'FunctionalAreaName', visible: true },
        { title: 'Código Posición Jerárquica', property: 'FunctionalIDJsonCode', visible: true },
        { title: 'Nombre Posición Jerárquica', property: 'FunctionalIDName', visible: true },
        { title: 'Fecha de Inicio', property: 'InitContract', mask: MASK_DATE, visible: true },
        { title: 'Ingreso Nación', property: 'NationInit', mask: MASK_DATE, visible: true },
        // { title: 'Utilizar Tipo de Payroll', property: 'UsePayrollType', visible: true },
        // { title: 'Tipo de Payrol', property: 'PayrollTypeName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
        { title: 'EPS', property: 'EPSName', visible: true },
        { title: 'ARP', property: 'ARPName', visible: true },
        { title: 'CCF', property: 'CCFName', visible: true },
        { title: 'Fondo Pensional', property: 'FPName', visible: true },
        { title: 'Fondo Cesantías', property: 'FCEName', visible: true },
        { title: 'Tipo de Salario', property: 'RevenueType', visible: true },
        { title: 'Salario', property: 'Revenue', mask: MASK_MONEY, visible: true },
        { title: 'Usar Salario Definido en el Contrato', property: 'UseContractSalaryValue', visible: true },
        { title: 'Salario Definido por Contrato', property: 'ContractSalaryValue', mask: MASK_MONEY, visible: true },
        { title: 'Tipo Riesgo', property: 'ARPRiskName', visible: true },
        { title: 'Tipo Cotizante', property: 'EmployeeTypeName', visible: true },
        { title: 'Subtipo Cotizante', property: 'EmployeeSubtypeName', visible: true },
        { title: 'Fecha Renuncia', property: 'EndingDate', mask: MASK_DATE, visible: true },
        { title: 'Estado', property: 'ContractStateName', visible: true },
        { title: 'Fecha Liquidación', property: 'UptoContract', mask: MASK_DATE, visible: true },
        { title: 'Fecha de Nacimiento', property: 'BornDate', mask: MASK_DATE, visible: true },
        { title: 'Dirección', property: 'Address', mask: MASK_TEXT_NOWRAP, visible: true },
        { title: 'Teléfono', property: 'Tel', visible: true },
        { title: 'Correo Electrónico', property: 'eMail', visible: true },
        { title: 'Género', property: 'GenType', visible: true },
        { title: 'Resposable ImpoRenta', property: 'RentTax', visible: true },
        { title: 'Último Exámen Médico', property: 'HealthTestDate', mask: MASK_DATE, visible: true },
        { title: 'Últimas Vacaciones', property: 'LastVacDate', mask: MASK_DATE, visible: true },
        { title: 'Última Dotación', property: 'LastEndowmentDate', mask: MASK_DATE, visible: true },
        { title: 'Tipo de Empleo', property: 'EmploymentTypeName', visible: true },
        { title: 'Código CIIU', property: 'CIIUCode', mask: MASK_NUMBER, visible: true },
        { title: 'Subtipo ARL', property: 'ARPRiskName', visible: true },
        { title: 'Tipo de Contrato', property: 'EmployeeContractType', visible: true },
        { title: 'Definir Límite de UVTs', property: 'UseUVTMaxRetefuente', visible: true },
        { title: 'Limite UVTs', property: 'UVTMaxRetefuente', visible: true },
        { title: 'Ciudad de Ejecución del Contrato', property: 'SiteIDName', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
        { title: 'Actualizado por', property: 'LastUpdateEmployeeName', visible: true },
        { title: 'Método de Cálculo', property: 'IDTaxRetentionMethodName', visible: true },
        { title: '% Fijo de Retención para el Procedimiento 2', property: 'TaxRetentionPercent2', visible: true },
        { title: 'Fecha Última Actualización', property: 'LastUpdate', visible: true, mask: MASK_DATE },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Definir Centro de Costo', property: 'UseOwnCostingCenter', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Utilizar Tipo de Payroll', property: 'UsePayrollType', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
        { title: 'Documento de Liquidación', property: 'DocLiq', visible: true },
        { title: 'Perídos Pendientes de Vacaciones', property: 'VacPendingPeriods', visible: true },
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar Contrato', icono: 'ri-file-edit-line', visible: true, evento: () => { setModal({ ...modal, "name": "Editar Contrato Laboral", "view": true }) } },
            { titulo: 'Modificar Nivel Salarial', icono: 'ri-edit-2-line', visible: true, evento: () => { modifySalary.open() } },
            { titulo: 'Modificar Plaza Laboral', icono: 'ri-edit-2-line', visible: true, evento: () => { modifyArea.open() } },
            { titulo: 'Vincular CDPs/RPs', icono: 'ri-file-add-line', visible: true, evento: () => { setModalLinkCDP({ ...modalLinkCDP, "name": "Vincular CDPs/RPs", "view": true }) } },
            { titulo: 'Definir IBC para Liquidación de Payroll', icono: 'ri-file-add-line', visible: true, evento: () => { setModalIBC({ ...modalIBC, "name": "Definir IBC para Liquidación de Payroll", "view": true }) } },
            { titulo: 'Cambiar Centro de Costo', icono: 'ri-arrow-left-right-line', visible: true, evento: () => { setModalcosto({ ...modalcosto, "name": "Cambiar Centro de Costo", "view": true }) } },
            { titulo: 'Recalcular provisiones', icono: 'ri-refresh-line', visible: true, evento: () => { setModalcalculate({ ...modalcalculate, "name": "Recalcular provisiones", "view": true }) } },
            { titulo: 'Detalle de Provisiones', icono: 'ri-list-check', visible: true, evento: () => { setModalPROV({ ...modalPROV, "name": "Detalle de Provisiones", "view": true }) } },
            { titulo: 'Agregar Historial de contrato', icono: 'ri-file-add-line', visible: true, evento: () => { setModalAddHistory({ ...modalAddHistory, "name": "Agregar Historial de contrato", "view": true }) } },
            { titulo: 'Historial de Contrato Laboral', icono: 'ri-list-check-2', visible: true, evento: () => { setModalHistory({ ...modalHistory, "name": "Historial de Contrato Laboral", "view": true }) } },
            { titulo: 'Ver Histórico de Cambios de Centro de Costo', icono: 'ri-list-unordered', visible: true, evento: () => { setModalhistorico({ ...modalhistorico, "name": "Ver Histórico de Cambios de Centro de Costo", "view": true }) } },
            { titulo: 'Documentos/Expedientes Laborales/Actos Administrativos', icono: 'ri-file-list-line', visible: true, evento: () => { setModalacciones({ ...modalacciones, "name": "Documentos/Expedientes Laborales/Actos Administrativos", "view": true }) } },
            { titulo: 'Ver Documento de Liquidación', icono: 'ri-file-search-line', visible: true, evento: () => { setModalDocLiq({ ...modalDocLiq, "name": "Ver Documento de Liquidación", "view": true }) } },
            { titulo: 'Identificación', icono: 'ri-user-search-line', visible: true, evento: () => { modalCarnet.open() } },
            { titulo: 'Hoja de Vida', icono: 'ri-book-mark-line', visible: true, evento: () => { modalDossier.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const actionsDropDown = [
        { id: 1, name: 'Exportar', permiso: null, activo: true },
        { id: 2, name: 'Actualizar Fecha Terminación Contrato', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={buttonEvent}></DropDown>
                </div>
            </div>
        )
    }
    const buttonEvent = (e) => {
        if (e.id === 1) {
            getListaReport();
            modalExportList.open();

        } else if (e.id == 2) {
            modaldate.open();
        }

    }

    const taps = [
        { id: 0, name: 'Información Contrato' },
        { id: 1, name: 'Información interna' },
        { id: 2, name: 'Seguridad Social y Aportes' },
        { id: 3, name: 'Retención en la Fuente' },
        { id: 4, name: 'Liquidación Final de Contrato' },
    ]

    const [indexTap, setIndexTap] = useState(0);

    const clearFilter = () => {
        setVigenia(single.getCurrenYear());
        setMonth(single.getCurrentMonth());
        setContractState(2);
        setListaAccs([]);
        setEmploymentType(NaN)
        setFuntional(NaN)
        setEntailment(NaN)
        setAppointment(NaN)
        setIdSite(NaN)
        setLista([]);
    }
    const filter = () => {
        return (
            <>
                <div className="row ">
                    <div className="col-md-4">
                        <MultiAccountanEditor values={listaAccs} label="Filtro Empleados" onChange={(e) => { setListaAccs(e) }} />
                    </div>
                    <div className="col-md-4">
                        <EmploymentTypeEditor label="Tipo de Grupo Laboral" idSelector={employmentType} onChange={(e) => { setEmploymentType(e) }} />
                    </div>
                    <div className="col-md-4">
                        <SelectFunctionalID label="Unidad Organizacional" onChange={(e) => { setFuntional(e?.IDLn) }} />
                    </div>
                    <div className="col-md-4">
                        <EntailmentEditor label="Nivel Jerárquico" idSelector={entailment} onChange={(e) => { setEntailment(e) }} />
                    </div>
                    <div className="col-md-4">
                        <AppointmentEditor label="Nivel Salarial" idSelector={appointment} onChange={(e) => { setAppointment(e) }} />
                    </div>
                    <div className="col-md-4">
                        <SelectSiteID label="Ubicación Geográfica" edit idLnSite={idSite} onChange={(e) => { setIdSite(e.IDLn) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStx} onChange={(e) => { setRegexStx(e.target.value) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Número de Registros Por Pagina</label>
                        <input type="number" className="form-control" value={registers} onChange={(e) => { setRegisters(parseInt(e.target.value)) }} />
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-12 mt-4">
                        <div className="row">
                            <div className="col-md-2 largerow"><BasicButton icon="ri-search-line" eventClick={() => paginador.page === 1 ? getLista() : paginador.setPage(1)}>Buscar</BasicButton>
                            </div>

                            <div className="col-md-3"> <BasicButton clase="danger" icon="ri-delete-bin-2-line" eventClick={() => clearFilter()}>Limpiar Filtros</BasicButton></div>
                            <div className="col-md-7">
                                <BasicButton icon="ri-bar-chart-horizontal-fill" clase="btn btn-outline-primary btn-border" eventClick={verimp}>
                                    Importar Valores para Liquidación Final
                                </BasicButton>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const modalUpdateExcel = useModal("Actualizar Mediante Excel", MODAL_md);
    const [listImport, setListImport] = useState([]);

    const importMenu = async () => {
        let existe: string[] = [];
        let errores: number[] = [];
        let noEncontrados: number[] = [];

        lista.forEach(element => {
            const id = String(element.DataBeanProperties.IDContract).trim();
            existe.push(id);
        });

        console.log("IDs existentes:", existe);

        for (let index = 1; index < listImport.length; index++) {
            const row = listImport[index];
            const idImport = String(row[0]).trim();

            if (existe.includes(idImport)) {
                const original = lista.find(element =>
                    String(element.DataBeanProperties.IDContract).trim() === idImport
                );

                if (original) {
                    const obj = {
                        ...original.DataBeanProperties,
                        UseOwnCostingCenter: row[1],
                        CostingCenter: row[2],
                        UsePayrollType: row[3],
                        IDPayrollType: row[4],
                        IDEmployeeLastUpdate: _single.getAccountID()
                    };

                    try {
                        await employeeContract.updateCustonBean(obj).then(
                            (resp) => {
                                console.log(resp)
                                single.update(bean)
                            }
                        )
                        toast.success(`Contrato de ${obj.AccountName} actualizado`);
                    } catch (err) {
                        toast.error(`Error al actualizar el item en la fila ${index + 1}`);
                        errores.push(index);
                    }
                }
            } else {
                toast.warning(`ID no encontrado: ${idImport}`);
                noEncontrados.push(index);
            }
        }

        console.log("Salida");
        await getLista();

        setModal({ ...modal, view: false });
        modalUpdateExcel.close();

        if (errores.length > 0) {
            toast.error(`Error al actualizar los siguientes items: ${errores.join(", ")}`);
        }

        if (noEncontrados.length > 0) {
            toast.warning(`IDs no encontrados en las filas: ${noEncontrados.join(", ")}`);
        }
    };


    const iconButtonsItem = [
        { nombre: 'Importar', visible: _single.canCreate(), icono: 'ri-file-excel-line', evento: () => { modalUpdateExcel.open(); } }
    ]

    const updateSalary = () => {
        if (bean.IDAppointment && bean.FromSelectedDate) {
            employeeContract.instance.setAppointmentToEmployeeContract(bean.IDContract, bean.IDAppointment, bean.FromSelectedDate, _single.getAccountID()).then(
                (resp) => {
                    modifySalary.close();
                    getLista();
                }
            ).catch(
                err => {
                    toast.error(err)
                }
            )
        } else {
            toast.error("Todos los campos son Obligatorios")
        }
    }

    const updateArea = () => {
        if (bean.FromSelectedDate && bean.IDLnFunctionalArea) {
            employeeContract.instance.setFunctionalAreaToEmployeeContract(bean.IDContract, bean.FromSelectedDate, bean.IDLnFunctionalArea, single.getAccountID()).then(
                (resp) => {
                    modifyArea.close();
                    getLista();
                }
            ).catch(
                err => {
                    toast.error(err)
                }
            )
        } else {
            toast.error("Todos los campos son Obligatorios")
        }
    }

    return (
        <BasicPage titulo="Historial de Contratos de Trabajo">
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-4">
                            <label>Vigencia:</label>
                            <input type="number" className="form-control" value={vigencia} onChange={(e) => { setVigenia(parseInt(e.target.value)) }} />
                        </div>
                        <div className="col-4">
                            <SelectMonths idSelector={month} onChange={(e) => { setMonth(e) }}></SelectMonths>
                        </div>
                        <div className="col-4">
                            <ConstractStateEditor label="Estado del Contrato" idSelector={contractState} onChange={(e) => { setContractState(e) }} />
                        </div>
                    </div>
                </div>
            </div>
            {filter()}
            <div className="row">
                <div className="col-md-12">
                    <BasicTable
                        _exportList
                        iconButtons={iconButtonsItem}
                        headButtons={buttons()}
                        listButtons={listaBotones()}
                        head={head} body={lista}
                        rowSet={setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={registers}
                    // filterModal={filter()}
                    />
                </div>
            </div>

            <Modal modal={modalExportList.modal} updateModal={modalExportList.setModal}>
                {listE.length > 0 &&
                    <ExportXLSL customName={"Historial"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listE} onExport={(name: string) => {
                        single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                    }} />
                }
            </Modal>
            <div className="col-md-12">
                <Modal modal={modalDocLiq} updateModal={setModalDocLiq}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docs}
                                IDDocument={bean.CNFDocumentLocation}
                                Since={bean.CNFDate}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
            <Modal modal={modaldate.modal} updateModal={modaldate.setModal} eventModal={updateUptoDateEmployeeContracts}>
                <>
                    <div className="row">
                        <div className="col-md-12">
                            <FileInput
                                label='Archivo a importar'
                                directory='ImpoFactorSalarial'
                                onCreate={({ Media, MediaContext }) => { upto.setBean({ ...upto.bean, "Media": Media, "MediaContext": MediaContext }) }}
                            />
                        </div>
                        <div className="col-md-12 mt-4">
                            <strong>Formato Plantilla</strong><br />
                            <small>IDContrato | Nombre | cedula | Fecha Renuncia | Fecha Liquidación</small>
                        </div>
                    </div>
                </>
            </Modal>
            <Modal modal={modalimpvalue} updateModal={setModalimpvalue} eventModal={importEmployeeContractDataForEndup}>
                <>
                    <div className="row">
                        <div className="col-md-12">
                            <FileInput
                                label='Archivo a importar'
                                directory='ImpoFactorSalarial'
                                onCreate={({ Media, MediaContext }) => { impvalue.setBean({ ...impvalue.bean, "Media": Media, "MediaContext": MediaContext }) }}
                            />
                        </div>
                    </div>
                </>
            </Modal>
            <Modal modal={modalcalculate} updateModal={setModalcalculate} eventModal={recalculateEmployeeProvisions}>

                <div className="row">
                    <div className="col-md-12">
                        <AccountantYear idSelector={form.Year} onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <MonthEditorbyconst idSelector={form.Month} onChange={(e) => { setForm({ ...form, "Month": e }) }} />
                    </div>
                </div>

            </Modal>
            <Modal modal={modalCarnet.modal} updateModal={modalCarnet.setModal}>
                <div className="row">
                    <div className="col">
                        <EmployeeID key={bean.IDAccount} idAccount={bean.IDAccount} />
                    </div>
                </div>
            </Modal>
            <Modal modal={modalIBC} updateModal={setModalIBC}>
                <div className="row">
                    <div className="col-md-12">
                        <IBCCatalog accountID={bean.IDAccount}/>
                    </div>
                </div>
            </Modal>
            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={() => { update() }} >
                    <EditEmployeeContract bean={bean} setBean={setBean} />
                </Modal>
            }

            {modalAddHistory.view &&
                <Modal modal={modalAddHistory} updateModal={setModalAddHistory} eventModal={create} >
                    <div className="row">
                        <div className="col-md-6">
                            <InputDate name="InitDate" label="Fecha de Inicio" value={bean.InitDate} setDate={(e) => { setBean({ ...bean, "InitDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <InputDate name="UptoDate" label="Fecha de Fin" value={bean.UptoDate} setDate={(e) => { setBean({ ...bean, "UptoDate": e }) }} />
                        </div>
                        <div className="col-12">
                            <AppointmentEditor label="Nivel Salarial" idSelector={null} onChange={(e) => { setBean({ ...bean, "IDAppointment": e }) }} />
                        </div>
                        <div className="col-12">
                            <label>Valor del Salario</label>
                            <input type="number" className="form-control" value={null} onChange={(e) => { setBean({ ...bean, "LastSalary": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            }

            {modalcosto.view &&
                <Modal modal={modalcosto} updateModal={setModalcosto} eventModal={addCostingCenterHistory}>
                    <>
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate name="FromDate" label="Fecha Desde" value={CostingCenterHistory.bean.FromDate} setDate={(e: any) => { CostingCenterHistory.setBean({ ...CostingCenterHistory.bean, "FromDate": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <CostingCenterSelect fKey="Code" idSelector={bean.CostingCenter} label="Centro de Costo" onChange={(e) => { CostingCenterHistory.setBean({ ...CostingCenterHistory.bean, "CostingCenterCode": e }) }} />
                            </div>
                        </div>
                    </>
                </Modal>
            }
            {modalhistorico.view &&
                <Modal modal={modalhistorico} updateModal={setModalhistorico}>
                    <>
                        <div className="row">
                            <CostingCenterHistoryCatalog idAccount={bean.IDAccount} />
                        </div>
                    </>
                </Modal>
            }
            {modalacciones.view &&
                <Modal modal={modalacciones} updateModal={setModalacciones}>
                    <>
                        <div className="row">
                            <PayrollDocumentCatalog idContract={bean.IDContract} />
                        </div>
                    </>
                </Modal>
            }
            {modalHistory.view &&
                <Modal modal={modalHistory} updateModal={setModalHistory} >
                    <ContractHistory _IDContract={bean.IDContract}></ContractHistory>
                </Modal>
            }

            {modalLinkCDP.view &&
                <Modal modal={modalLinkCDP} updateModal={setModalLinkCDP} >
                    <CDPLink _IDContract={bean.IDContract} />
                </Modal>
            }

            {modalExport.view &&
                <Modal modal={modalExport} updateModal={setModalExport} >
                    <ExportEmployeeContract />
                </Modal>
            }

            {modalImport.view &&
                <Modal modal={modalImport} updateModal={setModalImport} >
                    <ImportEmployeeContract />
                </Modal>
            }

            {modalUpdateParameters.view &&
                <Modal modal={modalUpdateParameters} updateModal={setModalUpdateParameters} eventModal={updateFunctionalArea} >
                    <div className="row">
                        <div className="col-12">
                            <label>Fecha desde la que aplica el cambio</label>
                            <InputDate name="fromDate" value={bean.fromDate} setDate={(e) => { setBean({ ...bean, "fromDate": e }) }} />
                        </div>
                    </div>
                    <div className="col-12">
                        <AppointmentEditor seeMoney={true} label="Nivel Salarial" idSelector={bean.IDAppointment} onChange={(e) => { setBean({ ...bean, "IDAppointment": e }) }} />
                    </div>
                    <div className="col-12">
                        <SelectFunctionalArea onChange={(e) => { setBean({ ...bean, "IDLnFunctionalArea": e.IDLn }) }} />
                    </div>
                </Modal>
            }

            <Modal modal={modifyArea.modal} updateModal={modifyArea.setModal} eventModal={() => { updateArea() }} >
                <div className="row">
                    <div className="col-md-12">
                        <label>Fecha Desde</label>
                        <InputDate notDate label=" " name="" value={null} setDate={(e) => { setBean({ ...bean, FromSelectedDate: e }) }} />
                    </div>
                    <div className="col-12">
                        <label>Plaza Laboral</label>
                        <SelectFunctionalArea label=" " onChange={(e) => { setBean({ ...bean, "IDLnFunctionalArea": e.IDLn }) }} />
                    </div>
                </div>
            </Modal>

            <Modal modal={modifySalary.modal} updateModal={modifySalary.setModal} eventModal={() => { updateSalary() }} >
                <div className="row">
                    <div className="col-md-12">
                        <label >Fecha Desde</label>
                        <InputDate name="" label=" " value={null} notDate setDate={(e) => { setBean({ ...bean, FromSelectedDate: e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Nivel Salarial</label>
                        <AppointmentCatalog render={bean.Name} idSelector={bean.IDAppointment} onChange={(e) => { setBean({ ...bean, "IDAppointment": e.IDAppointment, "Name": e.Name }) }} label=" " returnType="Object" />
                        {/* <AppointmentEditor label=" " idSelector={bean.IDAppointment} onChange={(e) => { setBean({ ...bean, "IDAppointment": e }) }} />getAppointmentCatalog */}
                    </div>
                </div>
            </Modal>
            <Modal modal={modalPROV} updateModal={setModalPROV}>
                <>
                    <div className="row">
                        <ProvisionCatalog idAccount={bean.IDAccount} />
                    </div>
                </>
            </Modal>
            <div className="col-md-12">
                <Modal modal={modalUpdateExcel.modal} updateModal={modalUpdateExcel.setModal} eventModal={importMenu} onSubmitLabel="Importar">
                    <div className="row">
                        <div className="col">
                            <ImportXLSX lodaData={setListImport} />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalDossier.modal} updateModal={modalDossier.setModal}>
                    <EmployeeDossier idAccount={bean.IDAccount}/>
                </Modal>
            </div>
        </BasicPage>

    )
}